/* ============================================================
   assets/int-short-subtitle.js              INTENTION — 2026-09-03
   THE SHORT TYPE LINE, AS A SUBTITLE UNDER THE TITLE.
   Both templates, every width.

   Nils: "On both apparel and framed print add the 'short' title from under
   the big image on mobile as a subtitle under the title. But in the format we
   had for subtitle before. Leave price out."

   The line under the hero is `.int-pdp-identity`, rendered by
   snippets/int-pdp-identity-line.liquid:
       apparel      "Unisex Sweatshirt 449,00 kr"
       framed print "Wood Frame with Matte paper 1.209,00 kr"
   The price is its own child, `.int-pdp-identity__price`.

   ⚑ CLONED, NOT RE-DERIVED. The short label is assembled in Liquid from
   several metafields, and the framed print version also folds in the paper
   word. Rebuilding that here would be a second source of truth that drifts
   the first time the Liquid changes. Cloning the node and dropping the price
   child cannot drift.

   ⚑ THE ORIGINAL LINE STAYS WHERE IT IS. It sits under the hero image on
   mobile with the price on it, and that is still wanted. This is an addition,
   not a move.

   ⚑ ITS OWN CLASS, NOT .product__subtitle. Reusing that class would look
   right and then be dragged around by the two order layers: the real subtitle
   is placed at 150 on apparel desktop and moved down the page on framed print
   mobile, and a second node carrying the class would follow it. The type is
   restated in assets/int-short-subtitle.css instead, matched to the real
   subtitle's computed values (16px / 400 / 22.4px / 0.96px / uppercase /
   #2B2B2B, measured 2026-09-03).
   ============================================================ */
(function () {
  'use strict';
  if (window.__intShortSub) return;
  window.__intShortSub = true;

  function mount() {
    if (document.querySelector('.int-short-sub')) return;

    var id = document.querySelector('.int-pdp-identity');
    var wrap = document.querySelector('.product__title__wrapper');
    if (!id || !wrap || !wrap.parentNode) return;

    var clone = id.cloneNode(true);
    clone.removeAttribute('id');
    clone.className = 'int-short-sub';
    var price = clone.querySelector('.int-pdp-identity__price');
    if (price) price.parentNode.removeChild(price);

    var text = (clone.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;
    clone.textContent = text;

    /* ⚑ THE ORDER GOES ON INLINE, NOT IN THE STYLESHEET. Measured: with
       `order: 1` in assets/int-short-subtitle.css the line still computed 50
       and landed at y=5005, near the foot of the phone column — the order
       layers set their default with a `> *` rule from an inline <style> in
       the head, which wins on source order over a linked sheet. Inline beats
       both. Same reason makeLead() writes its order inline. */
    clone.style.order = '1';
    wrap.parentNode.insertBefore(clone, wrap.nextSibling);

    /* ⚑ THE THEME SUBTITLE IS LEFT ALONE. An earlier pass hid it on framed
       print because it carries the same words as this line — measured on
       Dancing Cowboy, "Wood Frame with Matte Paper" against our "Wood Frame
       with Matte paper". Nils, 2026-09-03: "framed print desktop: add the
       real custom.subtitle above the description of material." It is the
       caption on the material paragraph that follows it (order 150, the
       paragraph 160), so it is wanted there even though the same words also
       sit under the title. Repetition here is deliberate; do not re-add a
       dedupe. */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
  /* The identity line carries a variant-dependent paper word, so it is
     repainted when the variant moves. Re-read it then. */
  document.addEventListener('variant:change', function () {
    setTimeout(function () {
      var src = document.querySelector('.int-pdp-identity');
      var dst = document.querySelector('.int-short-sub');
      if (!src || !dst) return;
      var c = src.cloneNode(true);
      var p = c.querySelector('.int-pdp-identity__price');
      if (p) p.parentNode.removeChild(p);
      var t = (c.textContent || '').replace(/\s+/g, ' ').trim();
      if (t && dst.textContent !== t) dst.textContent = t;
    }, 40);
  }, false);
})();
